export default {
    approvals: {
        title: "赞同",
        error: "发生错误"
    },
    delegates: {
        title: "代表",
        error: "发生错误",
        noDelegates: "没有物品",
        delegateDelete: "代表已被删除",
        confirm: {
            delete: "删除代表？"
        },
        delegates: {
            email: "电子邮件",
            startDate: "开始日期",
            endDate: "结束日期",
        },
        buttons: {
            add: {
                text: "添加代表"
            }
        }
    },
    employees: {
        title: "我的员工",
        error: "发生错误",
        empty: "未找到员工",
        users: {
            name: "姓名",
            email: "电子邮件"
        },
        model: {
            search: {
                placeholder: "搜索",
            }
        },
        cta: {
            orders: "加载订单",
            download: "下载订单",
            search: "搜索"
        }
    }
}